<script lang="ts">
  export let fill: string = "#150E0B";
</script>

<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M25.9542 8.56667L18.0208 16.5L25.9542 24.4333L24 26.3875L16.0667 18.4542L8.13333 26.3875L6.17917 24.4333L14.1125 16.5L6.17917 8.56667L8.13333 6.6125L16.0667 14.5458L24 6.6125L25.9542 8.56667Z"
    {fill}
  />
</svg>
